'use strict';

var _regeneratorRuntime = require("C:\\Users\\Gralath\\Documents\\VECHAIN\\voting-app\\node_modules\\@babel\\runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3Utils = require('web3-utils');

var debug = require('debug')('thor:injector');

var EthLib = require('eth-lib/lib');

var thor_devkit_1 = require("thor-devkit");

var utils = require("../utils");

var extendAccounts = function extendAccounts(web3) {
  // signTransaction supports both callback and promise style
  web3.eth.accounts.signTransaction = function signTransaction(ethTx, privateKey, callback) {
    debug('tx to sign: %O', ethTx);

    var sign = function sign(tx) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var chainTag, blockRef, gas, clause, body, ThorTx, priKey, signingHash, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (tx.chainTag) {
                  _context.next = 9;
                  break;
                }

                _context.next = 3;
                return web3.eth.getChainTag();

              case 3:
                chainTag = _context.sent;

                if (!chainTag) {
                  _context.next = 8;
                  break;
                }

                tx.chainTag = chainTag;
                _context.next = 9;
                break;

              case 8:
                throw new Error('error getting chainTag');

              case 9:
                if (tx.blockRef) {
                  _context.next = 18;
                  break;
                }

                _context.next = 12;
                return web3.eth.getBlockRef();

              case 12:
                blockRef = _context.sent;

                if (!blockRef) {
                  _context.next = 17;
                  break;
                }

                tx.blockRef = blockRef;
                _context.next = 18;
                break;

              case 17:
                throw new Error('error getting blockRef');

              case 18:
                if (!(tx.data && utils.isHex(tx.data))) {
                  _context.next = 22;
                  break;
                }

                tx.data = utils.toPrefixedHex(tx.data);
                _context.next = 27;
                break;

              case 22:
                if (!tx.data) {
                  _context.next = 26;
                  break;
                }

                throw new Error('Data must be valid hex');

              case 26:
                tx.data = '0x';

              case 27:
                if (tx.gas) {
                  _context.next = 36;
                  break;
                }

                _context.next = 30;
                return web3.eth.estimateGas({
                  from: EthLib.account.fromPrivate(utils.toPrefixedHex(privateKey)).address,
                  to: tx.to ? tx.to : '',
                  value: tx.value ? tx.value : 0,
                  data: tx.data
                });

              case 30:
                gas = _context.sent;

                if (!gas) {
                  _context.next = 35;
                  break;
                }

                tx.gas = gas;
                _context.next = 36;
                break;

              case 35:
                throw new Error('error getting gas');

              case 36:
                if (!tx.nonce) {
                  tx.nonce = utils.newNonce();
                }

                clause = {
                  value: tx.value || 0,
                  to: tx.to || null,
                  data: tx.data
                };
                body = {
                  chainTag: utils.validNumberOrDefault(tx.chainTag, 0),
                  blockRef: tx.blockRef,
                  gas: tx.gas,
                  expiration: utils.validNumberOrDefault(tx.expiration, utils.params.defaultExpiration),
                  gasPriceCoef: utils.validNumberOrDefault(tx.gasPriceCoef, utils.params.defaultGasPriceCoef),
                  dependsOn: !tx.dependsOn ? null : tx.dependsOn,
                  nonce: typeof tx.nonce === 'string' ? utils.toPrefixedHex(tx.nonce) : tx.nonce,
                  clauses: [clause]
                };
                debug('body: %O', body);
                ThorTx = new thor_devkit_1.Transaction(body);
                priKey = Buffer.from(utils.sanitizeHex(privateKey), 'hex');
                signingHash = thor_devkit_1.cry.blake2b256(ThorTx.encode());
                ThorTx.signature = thor_devkit_1.cry.secp256k1.sign(signingHash, priKey);
                result = {
                  rawTransaction: utils.toPrefixedHex(ThorTx.encode().toString('hex')),
                  messageHash: signingHash
                };
                return _context.abrupt("return", result);

              case 46:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }; // for supporting both callback and promise


    if (callback instanceof Function) {
      sign(ethTx).then(function (ret) {
        return callback(null, ret);
      }).catch(function (e) {
        return callback(e);
      });
    } else {
      return sign(ethTx);
    }
  };

  web3.eth.accounts.recoverTransaction = function recoverTransaction(encodedRawTx) {
    var values = EthLib.RLP.decode(encodedRawTx);
    var signingDataHex = EthLib.RLP.encode(values.slice(0, 9));
    var singingHashBuffer = thor_devkit_1.cry.blake2b256(Buffer.from(utils.sanitizeHex(signingDataHex), 'hex'));
    var signature = values[9];
    var signatureBuffer = Buffer.from(utils.sanitizeHex(signature), 'hex');
    var pubKey = thor_devkit_1.cry.secp256k1.recover(singingHashBuffer, signatureBuffer);
    var address = thor_devkit_1.cry.publicKeyToAddress(pubKey);
    return utils.toPrefixedHex(address.toString('hex'));
  };

  web3.eth.accounts.hashMessage = function hashMessage(data) {
    var message = web3Utils.isHexStrict(data) ? web3Utils.hexToBytes(data) : data;
    var messageBuffer = Buffer.from(message);
    var prefix = "\x19VeChain Signed Message:\n" + message.length.toString();
    var prefixBuffer = Buffer.from(prefix);
    var prefixedMessage = Buffer.concat([prefixBuffer, messageBuffer]);
    return utils.toPrefixedHex(thor_devkit_1.cry.blake2b256(prefixedMessage).toString('hex'));
  };

  web3.eth.accounts.sign = function sign(data, privateKey) {
    var hash = this.hashMessage(data);
    var hashBuffer = Buffer.from(utils.sanitizeHex(hash), 'hex');
    var privateKeyBuffer = Buffer.from(utils.sanitizeHex(privateKey), 'hex');
    var signature = thor_devkit_1.cry.secp256k1.sign(hashBuffer, privateKeyBuffer).toString('hex');
    return {
      message: data,
      messageHash: utils.toPrefixedHex(hash),
      signature: utils.toPrefixedHex(signature)
    };
  };

  web3.eth.accounts.recover = function recover(message, signature, preFixed) {
    var args = [].slice.apply(arguments);

    if (utils.isObject(message)) {
      return this.recover(message.messageHash, message.signature, true);
    }

    if (!preFixed) {
      message = this.hashMessage(message);
    }

    var hexBuffer = Buffer.from(utils.sanitizeHex(message), 'hex');
    var signatureBuffer = Buffer.from(utils.sanitizeHex(signature), 'hex');
    var pubKey = thor_devkit_1.cry.secp256k1.recover(hexBuffer, signatureBuffer);
    var address = thor_devkit_1.cry.publicKeyToAddress(pubKey);
    return utils.toPrefixedHex(address.toString('hex'));
  };
};

exports.extendAccounts = extendAccounts;